import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import TuneIcon from "@mui/icons-material/Tune";
import {
  Grid,
  Pagination,
  TableCell,
  TableFooter,
  TableRow,
  Typography,
} from "@mui/material";
import { capitalize, uniq } from "lodash";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import {
  getAllDiscountCodes,
  getBillingAllCollectionReportData,
  getBillingCollectionReportData,
} from "../../../redux/reducers/clinicSlice";
import { updatePaymentModeByCollectionId } from "../../../redux/reducers/paymentSlice";
import { AppColors } from "../../../util/AppColors";
import { w20h20BlueIcon } from "../../../util/CommonIconStyle";
import { paymentSourceTypes } from "../../../util/dropList";
import { tabEnum } from "../../../util/enum";
import { baseURL } from "../../../util/server";
import PaymentModeDropdown from "../../CommonComponents/PaymentModeDropdown";
import ReportTable from "../Reports/ReportTable";

const tableHdrs = [
  "invoiceNumber",
  // "invoiceDate",
  "customerUserName",
  "paymentDate",
  "source",
  "amtPaid",
  "paymentMode",
  "extraStatus",
  // "totalDue",
  // "balanceDue",
  // "discount",
  // "discountCode",
  // "taxes",
  // "customerUserName",
  // "petName",
];

const initSearch = {
  invoiceNumber: "",
  paymentMode: [],
  userName: "",
  petName: "",
  source: [],
};
const initFilter = {
  visible: false,
  added: false,
  selectedList: [],
  values: {},
};
const filterByList = [
  "Invoice Number",
  "Invoice Date",
  "Payment Date",
  "Amount Paid",
  "Total Due",
  "Balance Due",
  "Discount",
  // "Discount Code",
  "Taxes",
  // "Source",
];
const dropFields = ["Discount Code", "Source"];
const splitRows = [
  "Invoice Date",
  "Payment Date",
  "Amount Paid",
  "Total Due",
  "Balance Due",
  "Discount",
  "Taxes",
];
const initValues = {
  collectionId: null,
  visible: false,
  err: false,
  value: null,
};

const BillingCollectionsTableReport = ({
  paymentTableType,
  setPaymentTableType,
}) => {
  const dispatch = useDispatch();
  const [editColModVsble, setEditColModVsble] = useState(false);
  const [page, setPage] = useState(1);
  const [editModValues, setEditModvalues] = useState(initValues);
  const [searchValues, setSearchValues] = useState(initSearch);
  const [filterValues, setFilterValues] = useState(initFilter);
  const { discountCodes, billingCollectionReport, billingAllCollectionReport } =
    useSelector((state) => state?.clinic);
  const rowsPerPage = 10;
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { clinic: clinicDet } = useMemo(() => {
    if (!mandateDataRaw) {
      return { clinic: {} };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        clinic: reqData?.clinic ?? {},
      };
    } catch {
      return { clinic: {} };
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    dispatch(getAllDiscountCodes());
    dispatch(getBillingAllCollectionReportData());
  }, [dispatch]);

  useEffect(() => {
    if (paymentTableType === "today") {
      const reqObj = {
        ...filterValues,
        selectedList: [...(filterValues?.selectedList ?? []), "Payment Date"],
        values: {
          ...(filterValues?.values ?? {}),
          "Start Payment Date": new Date(),
          "End Payment Date": new Date(),
        },
      };
      setFilterValues(reqObj);
      onApiCall(1, false, reqObj);
      setPaymentTableType(null);
    }
  }, [paymentTableType]);

  useEffect(() => {
    if (!paymentTableType) {
      onApiCall();
    }
  }, [
    // searchValues?.invoiceNumber,
    searchValues?.paymentMode,
    searchValues?.userName,
    searchValues?.petName,
    searchValues?.source,
    paymentTableType,
  ]);

  const getFilterObj = (currentPage = 1, reset = false, filterObj = null) => {
    setPage(currentPage);
    const reqObj = { page: currentPage, itemSize: rowsPerPage };
    const filValues = filterObj ?? filterValues;
    if (reset) return reqObj;
    // if (searchValues?.invoiceNumber?.length > 0) {
    //   reqObj.invoiceNo = searchValues?.invoiceNumber;
    // }
    if (searchValues?.paymentMode?.length > 0) {
      reqObj.paymentMode = searchValues?.paymentMode?.map((li) => li?.value);
    }
    if (searchValues?.userName?.length > 0) {
      reqObj.userName = searchValues?.userName;
    }
    if (searchValues?.petName?.length > 0) {
      reqObj.petName = searchValues?.petName;
    }
    if (searchValues?.source?.length > 0) {
      reqObj.source = Array.isArray(searchValues?.source)
        ? searchValues?.source?.some((li) => li?.value?.toLowerCase() === "all")
          ? ["Clinic", "PETSHOP", "Pharmacy"]
          : (searchValues?.source ?? [])?.map((li) => li?.apiValue)
        : [];
    }

    if (
      filValues?.selectedList?.includes("Invoice Number") &&
      filValues?.values?.["Invoice Number"]?.length > 0
    ) {
      reqObj.invoiceNo = filValues?.values?.["Invoice Number"];
    }
    if (filValues?.selectedList?.includes("Invoice Date")) {
      reqObj.startInvoiceDate = moment(
        new Date(filValues?.values?.["Start Invoice Date"] ?? new Date()),
      ).format("YYYY-MM-DD");
      reqObj.endInvoiceDate = moment(
        new Date(
          filValues?.values?.["End Invoice Date"] ??
            filValues?.values?.["Start Invoice Date"] ??
            new Date(),
        ),
      ).format("YYYY-MM-DD");
    }
    if (filValues?.selectedList?.includes("Payment Date")) {
      reqObj.startPaymentDate = moment(
        new Date(filValues?.values?.["Start Payment Date"] ?? new Date()),
      ).format("YYYY-MM-DD");
      reqObj.endPaymentDate = moment(
        new Date(
          filValues?.values?.["End Payment Date"] ??
            filValues?.values?.["Start Payment Date"] ??
            new Date(),
        ),
      ).format("YYYY-MM-DD");
    }
    if (filValues?.selectedList?.includes("Amount Paid")) {
      reqObj.minAmountPaid = Number(
        filValues?.values?.["Min Amount Paid"] ?? 0,
      );
      reqObj.maxAmountPaid = Number(
        filValues?.values?.["Max Amount Paid"] ?? 0,
      );
    }
    if (filValues?.selectedList?.includes("Total Due")) {
      reqObj.minTotalDue = Number(filValues?.values?.["Min Total Due"] ?? 0);
      reqObj.maxTotalDue = Number(filValues?.values?.["Max Total Due"] ?? 0);
    }
    if (filValues?.selectedList?.includes("Balance Due")) {
      reqObj.minBalanceDue = Number(
        filValues?.values?.["Min Balance Due"] ?? 0,
      );
      reqObj.maxBalanceDue = Number(
        filValues?.values?.["Max Balance Due"] ?? 0,
      );
    }
    if (filValues?.selectedList?.includes("Discount")) {
      reqObj.minDiscount = Number(filValues?.values?.["Min Discount"] ?? 0);
      reqObj.maxDiscount = Number(filValues?.values?.["Max Discount"] ?? 0);
    }
    // if (filValues?.selectedList?.includes("Discount Code")) {
    //   reqObj.discountCode = filValues?.values?.["Discount Code"]?.map(
    //     (li) => li?.value,
    //   );
    // }
    if (filValues?.selectedList?.includes("Taxes")) {
      reqObj.minTaxes = Number(filValues?.values?.["Min Taxes"] ?? 0);
      reqObj.maxTaxes = Number(filValues?.values?.["Max Taxes"] ?? 0);
    }
    if (filValues?.selectedList?.includes("Source")) {
      reqObj.source = Array.isArray(filValues?.values?.["Source"])
        ? filValues?.values?.["Source"]?.some(
            (li) => li?.value?.toLowerCase() === "all",
          )
          ? ["Clinic", "Pet Shop", "Pharmacy"]
          : (filValues?.values?.["Source"] ?? [])?.map((li) => li?.value)
        : [];
    }
    return reqObj;
  };

  const onApiCall = (pge = 1, reset = false, filterObj = null) => {
    dispatch(
      getBillingCollectionReportData(getFilterObj(pge, reset, filterObj)),
    );
  };

  const totalPage = Math.ceil(
    (billingCollectionReport?.totalRecords ?? 0) / rowsPerPage,
  );

  const handleChangePage = (e, selectedPage) => {
    onApiCall(selectedPage);
  };

  const handleEdit = (itm) => {
    setEditModvalues({
      ...editModValues,
      visible: true,
      collectionId: itm?.collectionId,
      value: { name: itm?.paymentMode, value: itm?.paymentMode },
    });
  };

  const onCloseEditMod = () => {
    setEditModvalues(initValues);
  };

  const getTableData = () => {
    return (billingCollectionReport?.data ?? [])?.map((li) => {
      const reqDiscountCodes = (
        Array.isArray(li?.dicountCode) ? li?.dicountCode : []
      )?.map((nl) => {
        const reqCode = discountCodes?.find(
          (dc) => (dc?.billId ?? "")?.toString() === nl,
        );
        if (reqCode) return reqCode?.discountCode ?? "";
        return "";
      });
      return {
        source: tabEnum?.[li?.source],
        invoiceNumber: li?.invoiceNo,
        invoiceDate: moment(new Date(li?.invoiceDate)).format("DD MMM YYYY"),
        paymentDate: moment(new Date(li?.paymentDate)).format("DD MMM YYYY"),
        amtPaid: Number(li?.amountPaid)?.toFixed(2),
        paymentMode: li?.paymentMode,
        totalDue: Number(li?.totalDue ?? 0)?.toFixed(2),
        balanceDue: Number(li?.balanceDue ?? 0)?.toFixed(2),
        discount: Number(li?.dicount ?? 0)?.toFixed(2),
        discountCode: reqDiscountCodes,
        taxes: Number(li?.taxes ?? 0)?.toFixed(2),
        customerUserName: li?.userName ?? "",
        petName: li?.petName ?? "",
        extraStatus: (
          <div className="cursor" onClick={() => handleEdit(li)}>
            <div className="flex-center">
              <EditIcon sx={w20h20BlueIcon} />
            </div>
            <Typography className="blue-color fs8 txt-semi-bold text-align-center">
              Edit
            </Typography>
          </div>
        ),
      };
    });
  };

  const handleOpenChart = () => {
    console.log("Log triggered");
  };

  const onSearchChange = (e) => {
    const { name, value } = e?.target;
    setSearchValues({
      ...searchValues,
      [name?.trim()?.replace(/,$/, "")]: value, // remove spaces & trailing commas
    });
  };

  const onReset = () => {
    flushSync(() => {
      setSearchValues(initSearch);
    });
    flushSync(() => {
      setFilterValues({ ...initFilter, selectedList: [], values: {} });
    });
    onApiCall(1, true);
  };

  const onFilterChange = (name, value) => {
    const reqObj = { ...filterValues, [name]: value };
    setFilterValues(reqObj);
  };

  const getPetNames = () => {
    const reqList = (billingAllCollectionReport?.data ?? [])
      ?.map((li) => li?.petName)
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    return uniqList;
  };

  const getUserNames = () => {
    const reqList = (billingAllCollectionReport?.data ?? [])
      ?.map((li) => li?.userName)
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    return uniqList;
  };

  const getPaymentModes = () => {
    const reqList = (billingAllCollectionReport?.data ?? [])
      ?.map((li) => (li?.paymentMode ?? "")?.toLowerCase())
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    const reqDropList = uniqList?.map((li) => ({
      name: capitalize(li),
      value: li,
    }));
    return reqDropList;
  };

  const getInvoiceNumbers = () => {
    const reqList = (billingAllCollectionReport?.data ?? [])
      ?.map((li) => li?.invoiceNo)
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    return uniqList;
  };

  const onApplyFilter = () => {
    onApiCall();
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const getFieldName = (name, type) => {
    if (name === "Invoice Date") {
      if (type === "start") return "Start Invoice Date";
      return "End Invoice Date";
    }
    if (name === "Payment Date") {
      if (type === "start") return "Start Payment Date";
      return "End Payment Date";
    }
    if (name === "Total Due") {
      if (type === "start") return "Min Total Due";
      return "Max Total Due";
    }
    if (name === "Amount Paid") {
      if (type === "start") return "Min Amount Paid";
      return "Max Amount Paid";
    }
    if (name === "Balance Due") {
      if (type === "start") return "Min Balance Due";
      return "Max Balance Due";
    }
    if (name === "Discount") {
      if (type === "start") return "Min Discount";
      return "Max Discount";
    }
    if (name === "Taxes") {
      if (type === "start") return "Min Taxes";
      return "Max Taxes";
    }
  };

  const getDiscountCodes = () => {
    const reqList = (billingAllCollectionReport?.data ?? [])
      ?.flatMap((li) => [
        ...(li?.petShopDiscountId ?? []),
        ...(li?.pharmacyDiscountId ?? []),
        ...(li?.treatmentDiscountId ?? []),
      ])
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    const reqDropList = uniqList?.map((li) => {
      const reqCode = (discountCodes ?? [])?.find(
        (dc) => (dc?.billId ?? "")?.toString() === li,
      );
      return {
        name: reqCode?.discountCode ?? "",
        value: reqCode?.discountCode ?? "",
      };
    });
    return reqDropList;
  };

  const getDropListByType = (typ) => {
    return typ === "Discount Code"
      ? getDiscountCodes()
      : typ === "Source"
        ? paymentSourceTypes
        : [];
  };

  const onFilterValuesChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = {
      ...filterValues,
      values: {
        ...filterValues?.values,
        [name?.trim()?.replace(/,$/, "")]: value,
      },
    };
    setFilterValues(reqObj);
  };

  const onSelectFilter = (name) => {
    const reqObj = { ...filterValues };
    let reqList = filterValues?.selectedList;
    if (reqList?.includes(name)) {
      reqList = reqList?.filter((item) => item !== name);
    } else {
      reqList.push(name);
    }
    reqObj.selectedList = reqList;
    setFilterValues(reqObj);
  };

  const onFilterAdd = (value) => {
    const reqObj = { ...filterValues, added: value };
    setFilterValues(reqObj);
  };

  const onFilterReset = () => {
    const reqObj = {
      ...initFilter,
      visible: true,
      selectedList: [],
      values: {},
    };
    setFilterValues(reqObj);
  };

  const onCloseFilter = () => {
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const onDownloadReport = () => {
    const todayDate = moment(new Date()).format("YYYY-MM-DD");
    const thirtyDaysAgo = moment(
      new Date(new Date().setDate(new Date().getDate() - 30)),
    ).format("YYYY-MM-DD");
    const url = `${baseURL}/clinic/payment/collection/download-daily?startDate=${thirtyDaysAgo}&endDate=${todayDate}&clinicId=${clinicDet?.id}`;
    // `${baseURL}/clinic/payment/collection/download-daily?date=${reqDate}`;

    // /clinic/payment/collection/download-daily?startDate=2026-04-01&endDate=2026-04-07&clinicId=2
    // /clinic/payment/collection/download-daily?date=2026-04-01&clinicId=2
    window.open(url, "_blank");
  };

  const onChangeModValue = (val) => {
    setEditModvalues({
      ...editModValues,
      value: val,
      err: val?.value ? false : true,
    });
  };

  const updatePaymentMode = () => {
    if (!editModValues?.value?.value) {
      return setEditModvalues({ ...editModValues, err: true });
    }
    if (!editModValues?.collectionId) return;
    dispatch(
      updatePaymentModeByCollectionId({
        collectionId: editModValues?.collectionId,
        url: `?paymentMode=${editModValues?.value?.value}`,
      }),
    ).then((res) => {
      if (res?.payload) {
        onApiCall(page);
        onCloseEditMod();
      }
    });
  };

  return (
    <>
      <div className="flex-row mv10">
        <div className="top-row-cen-con w100Per">
          {/* <div className="w15Per">
            <CustomTextField
              options={getInvoiceNumbers()}
              value={searchValues?.invoiceNumber}
              name="invoiceNumber"
              handleChange={onSearchChange}
              label="Invoice Number"
              backgroundColor={AppColors.lightBlue2}
              fullWidth
              suggetions
            />
          </div> */}
          <div className="w15Per">
            <CustomTextField
              options={getUserNames()}
              value={searchValues?.userName ?? []}
              name="userName"
              handleChange={onSearchChange}
              label="Customer Name"
              backgroundColor={AppColors.lightBlue2}
              fullWidth
              suggetions
            />
          </div>
          <div className="w15Per ml20">
            <CustomTextField
              options={getPetNames()}
              value={searchValues?.petName}
              name="petName"
              handleChange={onSearchChange}
              label="Pet Name"
              backgroundColor={AppColors.lightBlue2}
              fullWidth
              suggetions
            />
          </div>
          <div className="w15Per ml20">
            <CustomSelect
              list={paymentSourceTypes}
              value={searchValues?.source ?? []}
              name="source"
              handleChange={onSearchChange}
              label="Source"
              multiSelectSearchCheck
              backgroundColor={AppColors.lightBlue2}
            />
          </div>
          <div className="w15Per ml20">
            <CustomSelect
              list={getPaymentModes()}
              value={searchValues?.paymentMode ?? []}
              name="paymentMode"
              handleChange={onSearchChange}
              label="Payment Mode"
              backgroundColor={AppColors.lightBlue2}
              multiSelectSearchCheck
            />
          </div>
          <div
            className="flex-row-ali-cen ml20 filter cursor"
            onClick={() => onFilterChange("visible", true)}
          >
            <TuneIcon sx={{ color: AppColors.appPrimary }} />
            <Typography className="font-medium fs12 blue-color ml10">
              {filterValues?.selectedList?.length > 0
                ? `${filterValues?.selectedList?.length} `
                : ""}
              Filter
            </Typography>
          </div>
          <div className="ml20">
            <CustomButton text="Reset" onClick={onReset} smallBtn redBtn />
          </div>
          <div className="ml20">
            <CustomButton text="⬇" onClick={onDownloadReport} smallBtn />
          </div>
        </div>
      </div>
      <Typography className="font-medium fs12 gray28 ml30">
        Number of Records: {billingCollectionReport?.totalRecords ?? 0}
      </Typography>
      <div className="mtMin10">
        <ReportTable datas={getTableData()} columns={tableHdrs} />
        <div className="flex1-end mtMin30">
          {Math.ceil(
            (billingCollectionReport?.totalRecords ?? 0) / rowsPerPage,
          ) > 1 ? (
            <TableFooter>
              <TableRow>
                <TableCell colSpan={12}>
                  <div className="flex1-end">
                    <Pagination
                      count={totalPage}
                      variant="outlined"
                      color="primary"
                      page={page}
                      onChange={handleChangePage}
                    />
                  </div>
                </TableCell>
              </TableRow>
            </TableFooter>
          ) : null}
        </div>
      </div>

      <CustomModal
        open={editModValues?.visible}
        onClose={onCloseEditMod}
        header="Change Payment Mode"
        modal
        modalWidth={30}
      >
        <div className="ph20">
          <div className="font-medium fs14 black2">Payment Mode</div>
          <PaymentModeDropdown
            list={[]}
            value={editModValues?.value}
            error={editModValues?.err}
            helperText={editModValues?.err ? "This field is required" : ""}
            onChange={(e) => onChangeModValue(e)}
            name="value"
            label=""
          />
          <div className="flex-center mv20">
            <div>
              <CustomButton
                smallBtn
                text="Update"
                onClick={updatePaymentMode}
              />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={filterValues?.visible}
        onClose={onCloseFilter}
        header="Filter"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="gray38 fs12 txt-regular">
                Filter by:
              </Typography>
              {!filterValues?.added ? (
                filterByList?.map((li, i) => (
                  <div className="flex-row-ali-cen" key={`${i}_li`}>
                    <div>
                      <CustomCheckbox
                        checked={filterValues?.selectedList?.includes(li)}
                        onChange={() => onSelectFilter(li)}
                      />
                    </div>
                    <Typography className="txt-regular fs14 black mb5 mlMin15">
                      {li}
                    </Typography>
                  </div>
                ))
              ) : (
                <div>
                  <div
                    className="flex-row-ali-cen gray-back4 ph10 pv10 br10 width-fit-con mt10 cursor"
                    onClick={() => onFilterAdd(false)}
                  >
                    <AddIcon
                      sx={{ color: AppColors.appPrimary, fontSize: 15 }}
                    />
                    <Typography className="font-medium fs12 blue-color ml5">
                      Add Filter
                    </Typography>
                  </div>
                  <div>
                    {filterValues?.selectedList?.map((li) => {
                      return (
                        <div className="mt20">
                          {dropFields?.includes(li) ? (
                            <CustomSelect
                              list={getDropListByType(li)}
                              value={filterValues?.values?.[li] ?? []}
                              name={li}
                              handleChange={onFilterValuesChange}
                              label={li}
                              multiSelectSearchCheck
                            />
                          ) : splitRows?.includes(li) ? (
                            <div className="flex-row-between-align-center">
                              <div className="w45Per">
                                <CustomTextField
                                  placeholder={getFieldName(li, "start")}
                                  fullWidth
                                  name={getFieldName(li, "start")}
                                  handleChange={onFilterValuesChange}
                                  value={
                                    filterValues?.values?.[
                                      getFieldName(li, "start")
                                    ] ?? ""
                                  }
                                  label={getFieldName(li, "start")}
                                  mobileDate={
                                    li === "Invoice Date" ||
                                    li === "Payment Date"
                                  }
                                  type="number"
                                />
                              </div>
                              <div className="w45Per">
                                <CustomTextField
                                  placeholder={getFieldName(li, "end")}
                                  fullWidth
                                  name={getFieldName(li, "end")}
                                  handleChange={onFilterValuesChange}
                                  value={
                                    filterValues?.values?.[
                                      getFieldName(li, "end")
                                    ] ?? ""
                                  }
                                  label={getFieldName(li, "end")}
                                  mobileDate={
                                    li === "Invoice Date" ||
                                    li === "Payment Date"
                                  }
                                  type="number"
                                />
                              </div>
                            </div>
                          ) : (
                            <CustomTextField
                              placeholder={li}
                              fullWidth
                              name={li}
                              handleChange={onFilterValuesChange}
                              value={filterValues?.values?.[li] ?? ""}
                              label={li}
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {!filterValues?.added ? (
                <div className="flex1-end mt15">
                  <div>
                    <CustomButton
                      text="Add"
                      smallBtn
                      onClick={() => onFilterAdd(true)}
                    />
                  </div>
                </div>
              ) : (
                <div className="flex-row-center mt15">
                  <div>
                    <CustomButton
                      text="Reset All"
                      smallBtn
                      onClick={onFilterReset}
                      tabSelectdBtn
                    />
                  </div>
                  <div className="ml20">
                    <CustomButton
                      text="Apply Filters"
                      smallBtn
                      onClick={onApplyFilter}
                    />
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      </CustomModal>
    </>
  );
};

export default BillingCollectionsTableReport;
